module.exports = __webpack_public_path__ + "static/media/pant_size.f9c856ca.jpeg";